/**
 * Investor brochure upload service — matches
 * /api/v1/investor-brochures/upload.
 */
import api from './api';
import { ApiResponse } from '../types';
import { InvestorBrochureUploadResponse } from '../types/investorBrochure';

export async function uploadInvestorBrochure(
  file: File
): Promise<ApiResponse<InvestorBrochureUploadResponse>> {
  try {
    const fd = new FormData();
    fd.append('file', file);
    const response = await api.post('/investor-brochures/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      // Claude extraction can take 10-20s for image-heavy tearsheets.
      timeout: 120_000,
    });
    return { data: response.data };
  } catch (err: any) {
    return {
      error:
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        'Failed to upload investor brochure',
    };
  }
}

const investorBrochureService = { uploadInvestorBrochure };
export default investorBrochureService;
